import { gql } from '@/Types/gql';

export const GET_TRAINER_PAYMENT = gql(`
query GetAllTrainerpayment($search: String, $filter: JSON, $sort: JSON, $limit: Int, $offset: Int, $getAllTrainerpaymentCountSearch2: String, $getAllTrainerpaymentCountFilter2: JSON, $formats: JSON) {
  getAllTrainerpayment(search: $search, filter: $filter, sort: $sort, limit: $limit, offset: $offset) {
    _id
    createdAt
    updatedAt
    amount
    trainerId
    note
    paidOn
    trainerName
    programDetails{
    programName
    }
    sessionStartTime
    sessionEndTime
    sessionTimeZone
    timeZone
    traineeName
    trainingTypeId
    trainingType {
      _id
      title
    }
    sessionUniqId
    sessionId
    transactionId
    status
    sessionCount
    traineeIdUser {
      _id
      firstName
      lastName
      profileImage(formats: $formats)
    }
    trainerIdUser {
      _id
      firstName
      lastName
    }
  }
  getAllTrainerpaymentCount(search: $getAllTrainerpaymentCountSearch2, filter: $getAllTrainerpaymentCountFilter2)
}
`);